import { render, staticRenderFns } from "./peservationInfo.vue?vue&type=template&id=1244b546&scoped=true&"
import script from "./peservationInfo.vue?vue&type=script&lang=js&"
export * from "./peservationInfo.vue?vue&type=script&lang=js&"
import style0 from "./peservationInfo.vue?vue&type=style&index=0&id=1244b546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1244b546",
  null
  
)

export default component.exports